/** Minimal prev/next pager shared by the operator lists. Hidden when there's
 *  only one page. */
const Pagination: React.FC<{
  page: number;
  pageCount: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
  label?: string;
}> = ({ page, pageCount, total, onPrev, onNext, label = 'items' }) => {
  if (pageCount <= 1) return null;
  const btn: React.CSSProperties = {
    padding: '0.35rem 0.7rem',
    border: '1px solid var(--gray-6)',
    borderRadius: 6,
    background: 'var(--gray-3)',
    color: 'var(--gray-12)',
    cursor: 'pointer',
  };
  const disabled: React.CSSProperties = { opacity: 0.4, cursor: 'not-allowed' };
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
        padding: '1rem 0',
      }}
    >
      <button type="button" style={{ ...btn, ...(page === 0 ? disabled : {}) }} onClick={onPrev} disabled={page === 0}>
        ‹ Prev
      </button>
      <span style={{ fontSize: '0.85rem', color: 'var(--gray-11)' }}>
        Page {page + 1} of {pageCount} · {total} {label}
      </span>
      <button
        type="button"
        style={{ ...btn, ...(page >= pageCount - 1 ? disabled : {}) }}
        onClick={onNext}
        disabled={page >= pageCount - 1}
      >
        Next ›
      </button>
    </div>
  );
};

export default Pagination;
